import { LinkCellRenderer } from "@/controls/ag-grid/components/ButtonCellRenderer";
import { ColDef } from "ag-grid-community";

export const useTableData = () => {
	const columns: ColDef[] = [
		{
			headerName: "Heat",
			field: "HeatNameValue",
			minWidth: 70,
			maxWidth: 70,
			cellRenderer: LinkCellRenderer,
			cellRendererParams: { linkProperty: "HeatNameLink" },
		},
		{
			headerName: "Grade",
			field: "Grade",
			minWidth: 98,
			maxWidth: 98,
		},
		{
			headerName: "Sample",
			field: "Sample",
			minWidth: 69,
			maxWidth: 69,
		},
		{
			headerName: "Elements",
			field: "Elements",
			wrapText: true,
			autoHeight: true,
			minWidth: 100,
			flex: 4,
		},
	];

	const defaultColDef: ColDef = {
		flex: 1,
		resizable: true,
		suppressHeaderMenuButton: true,
		autoHeight: true,
		wrapText: true,
	};

	return { columns, defaultColDef };
};
